export default __webpack_public_path__ + "static/media/assets.5118c083.svg";